<div id="map-container" class="map-container-presentation-v1" (mouseup)="mouseUpEvent()">
  <!-- Map Button Presentation  -->
  <div class="button-wrapper presentation-v1">
    <div
      class="fab-icon-holder"
      [ngClass]="{ 'engaged-button': stage?.visible }"
      [matTooltip]="stage?.visible ? 'Close Map' : 'Open Map'"
      matTooltipPosition="below"
    >
      <button mat-mini-fab class="material-icons" (click)="toggleMap()">
        <mat-icon>map</mat-icon>
      </button>
    </div>
  </div>

  <div
    class="mini-map-presentation-v1"
    [class.map-opened]="miniMapHelper.state === state.OPENED"
    [class.map-expanded]="miniMapHelper.state === state.EXPANDED"
    [class.mobile]="isMobileResponsiveWidth"
    style="--height: {{ stageHeight }}"
  >
    <div class="connected-room-presentation-v1" [class.hide]="!stage?.visible">
      <app-connected-rooms-select-option [initialSelectedRoomId]="selectedRoomId"></app-connected-rooms-select-option>
    </div>

    <div
      class="wrapper-presentation-v1"
      id="stage"
      [class.hide]="!stage?.visible"
      [class.drag-enabled]="draggingEnabled && !isCurrentlyDragging"
      [class.dragging]="draggingEnabled && isCurrentlyDragging"
    >
      <!-- Close Button -->

      @if (stage?.visible) {
        <div class="close-button" (click)="toggleMap()" matTooltip="Close Map">
          <mat-icon aria-hidden="true" aria-label="Close">cancel</mat-icon>
        </div>
      }

      <!-- Nav Controls Section   -->

      @if (miniMapHelper.state === state.EXPANDED || miniMapHelper.state === state.MOBILE) {
        <div class="nav-controls">
          <!-- Center Control  -->
          @if (isRoomLargerThanMini()) {
            <button
              title="Center map"
              class="center-button"
              [disabled]="miniMapHelper.isZoomOutMaxed()"
              (click)="centerOnPlayer()"
              matTooltip="Focus main player"
            ></button>
          }
          <!-- Zoom Controls -->
          @if (isRoomLargerThanMini()) {
            <div class="zoom-controls">
              <div
                class="zoom-button"
                [class.disabled]="miniMapHelper.isZoomInMaxed()"
                (click)="zoom(true)"
                matTooltip="Zoom In"
              >
                <mat-icon class="center-image zoom-in" svgIcon="ZOOM_IN"></mat-icon>
              </div>
              <div class="controls-divider"></div>
              <div
                class="zoom-button"
                [class.disabled]="miniMapHelper.isZoomOutMaxed()"
                (click)="zoom(false)"
                matTooltip="Zoom Out"
              >
                <mat-icon class="center-image zoom-out" svgIcon="ZOOM_OUT"></mat-icon>
              </div>
            </div>
          }
        </div>
      }

      <!-- Guest Count Label -->

      <div class="guest-container">
        <div class="guest-count">
          <mat-icon aria-hidden="true" aria-label="Guests">group</mat-icon>
          {{ guestCount }} {{ guestText }}
        </div>
      </div>

      <!-- Resize Icon -->

      @if (stage?.visible && !isMobileResponsiveWidth) {
        <div
          class="resize-container"
          [class.opened]="miniMapHelper.state === state.OPENED"
          [class.expanded]="miniMapHelper.state === state.EXPANDED"
        >
          <div
            class="resize-button"
            (click)="resizeMap()"
            [matTooltip]="miniMapHelper.state === state.OPENED ? 'Maximize map' : 'Minimize map'"
          >
            <mat-icon>photo_size_select_small</mat-icon>
          </div>
        </div>
      }

      <!-- Hover Over User Banner Detail -->

      @if (hoverUser) {
        <div
          class="hover-participant"
          [ngClass]="{ indicator: newVisualIndicators(), 'mouse-over': isMouseOver() }"
          [class.hide]="!stage?.visible"
          (mouseover)="mouseOverEvent()"
          (focus)="mouseOverEvent()"
        >
          @if (newVisualIndicators()) {
            <div class="user-wrapper indicator">
              <span class="text-overflow-ellipsis">{{ hoverUserName }}</span>
            </div>
            @if (hoverPlayer) {
              <div class="legend-div">
                <div>{{ hoverPlayerColorDescription }}</div>
                @if (hoverPlayerColor) {
                  <div class="legend-dot" style="--color: {{ hoverPlayerColor }}"></div>
                }
              </div>
            }
          } @else {
            <div class="user-wrapper">
              <profile-picture class="profile-container" [size]="30" [user]="hoverUser"></profile-picture>
              <span class="text-overflow-ellipsis">{{ hoverUserName }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
